import React, { useState, useEffect } from 'react';
import { FabricationProjectsService } from '../../../../../../../services/FabricationProjects';
import { useDispatch } from 'react-redux';
import { Modal } from '@gerdau/hefesto';
import { addToast } from '../../../../../../../store/ducks/toast/actions';
import { EToastTypes } from '../../../../../../../store/ducks/toast/types';
import { getTaggingInformationScreen } from '../../../../../../../utils/Tagging';
import { sendTagging } from '../../../../../../../store/ducks/tagging/actions';

interface RemoveProjectProps {
  projectId: number;
  projectName: string;
  contractNumber: string;
  onCancel: () => void;
  updateProjectsTable: () => void;
}

const RemoveProject: React.FC<RemoveProjectProps> = ({
  projectId,
  projectName,
  contractNumber,
  onCancel,
  updateProjectsTable
}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsloading] = useState(false);

  const { screenName = '', itemDescription = '' } = getTaggingInformationScreen(
    'modal-excluir-projeto'
  );

  useEffect(() => {
    dispatch(
      sendTagging({
        page: window.location.pathname,
        screenName,
        event: 'page_view'
      })
    );
  }, []);

  const removeSelectedProject = () => {
    setIsloading(true);

    FabricationProjectsService.removeProject(contractNumber, projectId)
      .then(() => {
        setIsloading(false);
        updateProjectsTable();
        dispatch(
          addToast({
            message: 'Projeto removido com sucesso.',
            type: EToastTypes.SUCCESS,
            durationInMS: 4000
          })
        );
        onCancel();
      })
      .catch((err) => {
        let errorMessage = 'Falha ao excluir o projeto. Tente novamente.';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((err as any)?.response?.data?.status === '400') {
          const messages: string[] =
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            Object.values((err as any)?.response?.data?.errors) || [];
          if (messages.length > 0) {
            errorMessage = messages[0];
          }
        }
        setIsloading(false);
        dispatch(
          addToast({
            message: errorMessage,
            type: EToastTypes.DANGER,
            durationInMS: 4000
          })
        );
      });
  };

  return (
    <Modal
      title="Deseja realmente excluir o projeto?"
      modalSize="sm"
      buttons={{
        left: {
          children: 'Cancelar',
          name: 'cancel',
          onClick: () => {
            onCancel();
            dispatch(
              sendTagging({
                page: window.location.pathname,
                screenName,
                itemDescription: `${itemDescription}cancelar`,
                event: 'click'
              })
            );
          },
          type: 'button',
          disabled: isLoading
        },
        right: {
          children: 'Excluir projeto',
          name: 'confirm-remove',
          onClick: () => {
            removeSelectedProject();
            dispatch(
              sendTagging({
                page: window.location.pathname,
                screenName,
                itemDescription: `${itemDescription}excluirProjeto`,
                event: 'click'
              })
            );
          },
          type: 'button',
          variant: 'danger',
          disabled: isLoading,
          loading: isLoading
        }
      }}
    >
      <span>
        Caso exclua o projeto <b>{projectName}</b> não será possível desfazer
        esta ação.
      </span>
    </Modal>
  );
};

export default RemoveProject;
